import React,{useEffect,useState} from 'react';
import { Grid,Box, TextField, Button, Typography, Paper,} from '@mui/material';
import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";
// import SearchIcon from '@mui/icons-material/Search';
// import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
// import {FormControl,InputLabel,Select,MenuItem,
    // TextField, IconButton } from '@mui/material';
// import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PDFLogo from "../../MeetingCard/StaticData/Svg/pdf-svgrepo-com.svg";
import { useGetAllActivePersonByTenantId } from '../../../OKRManagment/Hooks';
import MultiSelect from '../../../../components/FormikControls/MultiSelect/MultiSelect';
import { baseUrl } from '../../../../env';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import DYToastMessage from '../../../../components/GlobalComponents/DyToastMessage/DYToastMessage';
// import InputAdornment from '@mui/material/InputAdornment';

const GetPDFReport = ({onSuccesss,meetingId,editMode,onClose,setShowToastMessage,setAddStaffState}:any) => {

  const tenantId:string=useSelector((state:any)=>state.meetings.profileTenantId);
  const[personIdData,setPersonIdData]=useState([]);
  const [meetingSubject, setMeetingSubject] = useState("");
  const [selectedRowData, setSelectedRowData] = React.useState<any>([]);
  const{data:activePersonData,isLoading:getActivePersonLoading}=useGetAllActivePersonByTenantId(tenantId);
  const [showLtoastMessage, setShowLtoastMessage] = useState<any>(null);
  const [isSucces, SetIsSuccess] = useState<boolean>();
  const [tMessage, SetTMessage] = useState<string>();

    useEffect(() => {
        setPersonIdData(activePersonData?.map((item:any)=>{
            let{key,value}=item;
            return {year:value,title:key}
        }))
        }, [activePersonData]);

        // useEffect(() => {
        //   if (meetingSubject === '' || meetingSubject === null) {
        //       setShowLtoastMessage(true);
        //       SetIsSuccess(false);
        //       SetTMessage('موضوع جلسه اجباری می باشد');
        //   }
        // }, [meetingSubject]);

        // useEffect(() => {
        //   if (meetingSubject === '' || meetingSubject === null) {
        //       setShowLtoastMessage(true);
        //       SetIsSuccess(false);
        //       SetTMessage('موضوع جلسه اجباری می باشد');
        //   }
        // }, [meetingSubject]);

        const handleDownload = () => {
          const url = `${baseUrl}Download/MeetingPDFReport?meetingId=${meetingId}&personIds=${selectedRowData.join(
            ","
          )}&meetingSubject=${encodeURIComponent(meetingSubject)}`;
          window.open(url, "_blank");
        };

        return (
          <>
          <Paper elevation={3} style={{ padding: "24px", maxWidth: "600px", margin: "auto", marginTop: "32px" }}>
            <Typography variant="h5" style={{ marginBottom: "16px", textAlign: "center" }}>
            </Typography>
      
            <Box width={"100%"} textAlign={"center"}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="توضیحات"
                    variant="outlined"
                    value={meetingSubject}
                    multiline
                    minRows={5}
                    onChange={(e) => setMeetingSubject(e.target.value)}
                    InputLabelProps={{
                      style: { fontSize: "14px" },
                    }}
                  />
                </Grid>
      
                <Grid item xs={12}>
                  <MultiSelect
                    options={personIdData || []}
                    isLoading={getActivePersonLoading}
                    propName="teamIds"
                    minRows={5}
                    label={"انتخاب افراد حاضر"}
                    onChangee={(e: any, other: any) => {
                      setSelectedRowData(other);
                    }}
                  />
                </Grid>
      
                <Grid item xs={12} md={12} style={{ marginTop: "16px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDownload}
                  startIcon={<img src={PDFLogo} style={{ height: 28, width: 30 }} alt="PDFLogo" />}
                >
                دریافت فایل
              </Button>
            </Grid>
              </Grid>
            </Box>
          </Paper>
          {showLtoastMessage && (
          <DYToastMessage
            isSuccess={isSucces}
            message={tMessage}
            setShow={setShowLtoastMessage}
            show={showLtoastMessage}
          />
        )}
          </>
        );
      };

export default GetPDFReport